import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalHospital as LocalHospitalIcon} from '@material-ui/icons';
import {
  appointmentTags,
  newAppointmentTags,
  editAppointmentTags,
} from '~/config/routes';
import { toast } from 'react-toastify';
import { historyPropType } from '~/config/routerPropTypes';
import Request from '~/providers/Request';
import Context from './context';
import Paper from '~/components/Paper';
import ModalDelete from '~/components/ModalDelete';
import InputShow from '~/components/InputShow';
import PaperButtons from '~/components/PaperButtons';
import AppointmentTagsRecord from '~/records/AppointmentTagsRecord';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import { AbilityContext } from '~/contexts/Can';

const attrName = (attr) => AppointmentTagsRecord.hummanAttributeName(attr);

function ShowAppointmentTag({ history }) {
  const { id } = history.location.route.getParams();
  const { records, addRecords } = useContext(Context);
  const [record, setRecord] = useState(new AppointmentTagsRecord());
  const { t } = useTranslation();
  const [loading, setLoading] = useState(!records || !records[id]);
  const [modal, setModal] = useState(false);
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if (records && records[id]) {
      setRecord(record.updateAttributes(records[id]));
    }
    setLoading(true);
    Request.get(`/admin/appointment_tags/${id}`, {})
      .then((response) => {
        setLoading(false);
        addRecords({ data: [response.data] });
        setRecord(record.updateAttributes(response.data));
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  async function handleDelete() {
    setLoading(true);
    Request.del(`/admin/appointment_tags/${id}`)
      .then(() => {
        toast.success(t('delete-toast-success'));
        history.push(appointmentTags.spec);
      })
      .catch(() => {
        setLoading(false);
        toast.error(t('delete-toast-fail'));
      });
    setModal(false);
  }

  return (
    <Paper
      Icon={LocalHospitalIcon}
      iconColor="blue"
      title={t('appointmentTags.defSingular')}
      loading={loading}
      actions={
        <PaperButtons
          id={id}
          setModal={ability.can('delete', 'AppointmentTags') ? setModal : null}
          backRoute={appointmentTags}
          newRoute={ability.can('new', 'AppointmentTags') ? newAppointmentTags : null}
          editRoute={ability.can('edit', 'AppointmentTags') ? editAppointmentTags : null}
        />
      }
    >
      <GridContainer>
        <GridItem xs={12} md={12}>
          <InputShow label={attrName('name')} value={record.get('name')} />
        </GridItem>
      </GridContainer>

      <ModalDelete
        modal={modal}
        onClose={() => {
          setModal(false);
        }}
        name={record.get('name')}
        id={record.get('id')}
        deleteAction={handleDelete}
      />
    </Paper>
  );
}

ShowAppointmentTag.propTypes = {
  history: historyPropType,
};

export default ShowAppointmentTag;
